import { useState } from 'react';
import { CheckCircle2, Plus } from 'lucide-react';
import { EMPTY_INCIDENT_FORM, SEVERITY } from './mockIncidentData';

const inputClass =
  'w-full rounded-lg border border-logi-grid bg-white px-3 py-2 text-sm text-logi-text placeholder-logi-subtle outline-none transition focus:border-red-500/50 focus:ring-1 focus:ring-red-500/30';

const labelClass = 'mb-1 block text-[10px] font-semibold uppercase tracking-wider text-logi-text0';

export default function IncidentCreateForm({ onSubmit }) {
  const [form, setForm] = useState(EMPTY_INCIDENT_FORM);
  const [savedMsg, setSavedMsg] = useState('');

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.description.trim()) return;

    onSubmit?.({
      severity: form.severity,
      description: form.description.trim(),
      actionTaken: form.actionTaken.trim() || 'Incident logged · Awaiting HSE review',
    });

    setForm(EMPTY_INCIDENT_FORM);
    setSavedMsg('Incident logged and added to active ledger.');
    setTimeout(() => setSavedMsg(''), 3000);
  };

  return (
    <section className="rounded-xl border border-logi-grid bg-white p-4 sm:p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Plus className="h-4 w-4 text-red-700" strokeWidth={1.75} />
          <h3 className="text-sm font-bold text-logi-text">Log New Incident</h3>
        </div>
        {savedMsg && (
          <p className="flex items-center gap-1.5 text-xs font-medium text-emerald-700">
            <CheckCircle2 className="h-4 w-4" />
            {savedMsg}
          </p>
        )}
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-3 lg:grid-cols-4">
        <div>
          <label className={labelClass}>Severity</label>
          <select
            className={inputClass}
            value={form.severity}
            onChange={handleChange('severity')}
          >
            {Object.entries(SEVERITY).map(([key, cfg]) => (
              <option key={key} value={key}>
                {cfg.label}
              </option>
            ))}
          </select>
        </div>
        <div className="lg:col-span-2">
          <label className={labelClass}>Description</label>
          <input
            className={inputClass}
            placeholder="e.g. Spillage near depot, Tyre blowout on E11…"
            value={form.description}
            onChange={handleChange('description')}
            required
          />
        </div>
        <div>
          <label className={labelClass}>Initial Action (optional)</label>
          <input
            className={inputClass}
            placeholder="Immediate response taken…"
            value={form.actionTaken}
            onChange={handleChange('actionTaken')}
          />
        </div>
        <div className="lg:col-span-4">
          <button
            type="submit"
            className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-red-600 to-orange-600 px-4 py-2.5 text-xs font-bold uppercase tracking-wide text-white shadow-lg shadow-red-500/20 transition hover:from-red-500 hover:to-orange-500"
          >
            <Plus className="h-4 w-4" />
            Create Incident
          </button>
        </div>
      </form>
    </section>
  );
}
